import { createSelector } from 'reselect'
import { List } from 'immutable'

import { getEntity, getEntityMap } from 'data'
import { getActiveNoteId } from 'data/ui/selectors'

export const getThreadsMap = state => getEntityMap(state, 'Thread')
export const getThread = (state, threadId) =>
  getEntity(state, 'Thread', threadId)

export const getThreads = (state, threadIds) =>
  getEntityMap(state, 'Thread')
    .filter(thread => threadIds.indexOf(thread.id) !== -1)
    .sortBy(t => t.createdAt)

export const getThreadCommentIds = (state, threadId) => {
  const thread = getThread(state, threadId)
  if (!thread) {
    return []
  }
  return Object.keys(thread.comments.toJS() || {})
}

export const getThreadComments = createSelector(
  state => getEntityMap(state, 'Comment'),
  (state, threadId) => getThread(state, threadId),
  (allComments, thread) => {
    if (!thread) {
      return List()
    }
    const commentIds = thread.comments.map(c => c.get('id')).toSet()
    return allComments
      .filter(comment => commentIds.has(comment.id) && !comment.archivedAt)
      .sortBy(comment => new Date(comment.createdAt).getTime())
      .toList()
  }
)

export const getNoteThread = (state, noteId) =>
  getThreadsMap(state)
    .toList()
    .filter(thread => noteId === thread.noteId)

export const getCurrentNoteThreads = createSelector(
  getThreadsMap,
  getActiveNoteId,
  (allThreads, currentNoteId) =>
    allThreads.filter(thread => currentNoteId === thread.noteId).toList()
)

export const getCurrentNoteClosedThreadIds = createSelector(
  getCurrentNoteThreads,
  threads =>
    threads.map(({ id, resolvedAt }) => (resolvedAt ? id : null)).filter(x => x)
)

export const getCurrentNoteThreadIds = createSelector(
  getCurrentNoteThreads,
  threads => threads.map(({ id }) => id)
)

export const getThreadDraft = (state, id) => {
  return state.threads.threadDrafts.get(id)
}
